export const roadTestTypes = {
  select: {
    en: '',
    fr: '',
  },
  RTClass1: {
    en: 'Class 1 Semi/Tractor Trailer Licence',
    fr: `Classe 1 - Permis de tracteur/semi-remorque`,
  },
  RTClass2: {
    en: 'Class 2 Bus Licence',
    fr: `Classe 2 - Permis d’autobus`,
  },
  RTClass3: {
    en: 'Class 3 Heavy Commercial Licence',
    fr: `Classe 3 - Permis de véhicules utilitaire lourd`,
  },
  RTClass4: {
    en: 'Class 4 Public Passenger Licence',
    fr: `Classe 4 - Permis de véhicules routier de voyageurs de transport public`,
  },
  RTClass5: {
    en: 'Class 5 Operators Licence',
    fr: `Classe 5 - Permis de conducteur`,
  },
  RTClass6: {
    en: 'Class 6 Motorcycle Operators Licence',
    fr: `Classe 6 - Permis de motocyclette`,
  },
  RTMotocycleEndo: {
    en: 'Motorcycle Endorsement',
    fr: `Code de motocyclette`,
  },
  RTSchoolbusEndo: {
    en: 'School Bus Endorsement',
    fr: `Code d'autobus scolaire`,
  },
}
